<template>
  <RecycoGenericInputComponent :label="label" :icon="icon" :validate="validate" :value="value">
    <Datetime
      input-class="recyco-datetime-input"
      :title="label"
      :phrases="{
        ok: $t('ok'),
        cancel: $t('cancel'),
      }"
      :value="value"
      @input="input"
      v-bind="$attrs"
    />
  </RecycoGenericInputComponent>
</template>

<i18n>
  {
    "es": {
      "ok": "Ok",
      "cancel": "Cancelar"
    },
    "en": {
      "ok": "Ok",
      "cancel": "Cancel"
    }
  }
</i18n>

<script>
  import { Settings } from 'luxon';
  import { Datetime } from 'vue-datetime';
  import 'vue-datetime/dist/vue-datetime.css';

  import RecycoGenericInputComponent from './RecycoGenericInputComponent.vue';

  export default {
    name: 'recyco-datetime',
    components: {
      RecycoGenericInputComponent,
      Datetime,
    },
    props: {
      label: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
      },
      validate: {
        type: Function,
        default: () => null,
      },
      value: {
        type: String,
        default: (new Date()).toISOString(),
      },
    },
    data() {
      return {
      };
    },
    methods: {
      input(value) {
        this.$emit('input', value);
      },
    },
    mounted() {
      Settings.defaultLocale = this.$i18n.locale;
    },
  };
</script>

<style lang="scss">
  .recyco-datetime-input {
    width: 100%;
    box-sizing: border-box;

    font: inherit;
    padding: .4375em .75em;
    line-height: 1.5;
    color: inherit;
    background-color: white;
    // border: 1px solid $color-gray-ultra-light; // TODO
    border: 1px solid #aaaaaa;
    // will-change: border-color, box-shadow;
    will-change: border-color;
    border-radius: 1.5em;
    box-shadow: none;
    outline: 0;
    // transition: box-shadow .25s cubic-bezier(.27,.01,.38,1.06), border .25s cubic-bezier(.27,.01,.38,1.06), -webkit-box-shadow .25s cubic-bezier(.27,.01,.38,1.06);
    transition: border .25s cubic-bezier(.27,.01,.38,1.06);

    &:enabled:hover {
      // border-color: $color-gray-light; // TODO
      border-color: 1px solid #cccccc;
    }

    &:enabled:focus {
      border-color: var(--color-primary);
      // box-shadow: 0 .313rem .719rem rgba($color-primary, .1), 0 .156rem .125rem rgba(0, 0, 0, .06);
    }

    &:disabled {
      cursor: not-allowed;
      // color: $color-gray-light; // TODO
      color: #cccccc
    }
  }
</style>
